import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a1400] py-12 px-4" data-id="element-307">
      <div className="max-w-5xl mx-auto" data-id="element-308">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-12 text-center" data-id="element-309">
          <div data-id="element-310">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-311">
              +500
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-312">
              profes confían
            </div>
          </div>
          <div data-id="element-313">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-314">6</div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-315">
              Tomos listos
            </div>
          </div>
          <div data-id="element-316">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-317">6</div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-318">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-319">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-320">
              4.9/5
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-321">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-322">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-323">🇦🇷</div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-324">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-325">
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-326">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-327">
              SM
            </div>
            <div data-id="element-328">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-329">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-330">
                "Organicé todo el año de clases en una tarde. Nunca más llegué
                sin material a dar clase."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-331">
                — Sebastián M., Buenos Aires | Profesor de Piano Particular
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-332">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-333">
              CR
            </div>
            <div data-id="element-334">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-335">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-336">
                "Los planes de clase son exactamente lo que necesitaba. El
                sistema de evaluación me ahorra horas cada semana."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-337">
                — Claudia R., Rosario | Profesora de Piano en Academia
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-338">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-339">
              DP
            </div>
            <div data-id="element-340">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-341">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-342">
                "Nunca más llegué sin saber qué dar. Mis clases de alumnos
                avanzados por fin tienen estructura y progresión real."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-343">
                — Diego P., Córdoba | Profesor de Piano Independiente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}